/** Estado de uma etapa de aprovação: aprovado, reprovado ou pendente. */

import { Check, Minus, X } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { dataBR } from "@/lib/format";
import type { Classificacao, TipoAprovacao } from "@/types";

export const ETAPAS: { tipo: TipoAprovacao; rotulo: string }[] = [
  { tipo: "contabil", rotulo: "Contábil" },
  { tipo: "tax", rotulo: "Tax" },
  { tipo: "negocio", rotulo: "Negócio" },
];

/** Quem classificou, quando e por quê — vai no `title` do selo. */
export function descreverClassificacao(c: Classificacao) {
  const quem = `${c.decisao === "aprovado" ? "Aprovado" : "Reprovado"} por ${c.por ?? "usuário removido"} em ${dataBR(c.em)}`;
  return c.comentario ? `${quem}\n“${c.comentario}”` : quem;
}

export function SeloAprovacao({ classificacao }: { classificacao: Classificacao | null }) {
  if (!classificacao) {
    return (
      <Badge variant="neutro" title="Pendente de classificação">
        <Minus className="size-3" />
        Pendente
      </Badge>
    );
  }
  const aprovado = classificacao.decisao === "aprovado";
  return (
    <Badge variant={aprovado ? "ok" : "erro"} title={descreverClassificacao(classificacao)}>
      {aprovado ? <Check className="size-3" /> : <X className="size-3" />}
      {aprovado ? "Aprovado" : "Reprovado"}
    </Badge>
  );
}
